import React from "react";

/**
 * Honeypot anti-bot field.
 * Hidden from humans, but bots tend to fill all input fields.
 * If submitted with any value, backend silently rejects the submission.
 */
export default function HoneypotField({ value, onChange, name = "website" }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-9999px",
        top: "auto",
        width: 1,
        height: 1,
        overflow: "hidden",
      }}
    >
      <label>
        Sitio web (déjalo vacío)
        <input
          type="text"
          name={name}
          tabIndex={-1}
          autoComplete="off"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
    </div>
  );
}
